export const casinoRoutes = {
  home: 'home',
  slots: 'slots',
  favorites: 'favorites',
  game: 'game'
}
